import { DownloadGeoJsonButton } from "@/components/Attributes/DownloadGeoJsonButton";
import { OpenMapButton } from "@/components/Attributes/OpenMapButton";
import * as Config from "@/config";
import * as Common from "@/utils/common";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

interface MapShowRowsProps {
  attributes: Array<any>;
  dataAttributeValueMap: Map<string, any>;
  chooseComponent?: (
    attributes: Array<any>,
    dataAttributeValueMap: Map<string, any>
  ) => React.ReactNode;
}

const MapShowRows: React.FC<MapShowRowsProps> = ({
  attributes,
  dataAttributeValueMap,
  chooseComponent,
}) => {
  return (
    <>
      {attributes.map((attribute) => {
        if (Common.isMapDrawing(attribute)) {
          return (
            <MapRenderRow
              key={attribute.id}
              attribute={attribute}
              dataAttributeValueMap={dataAttributeValueMap}
              chooseComponent={chooseComponent}
            />
          );
        }
        return null;
      })}
    </>
  );
};

const MapRenderRow: React.FC<{
  attribute: any;
  dataAttributeValueMap: Map<string, any>;
  chooseComponent?: (
    attribute: any,
    dataAttributeValueMap: Map<string, any>
  ) => React.ReactNode;
}> = ({ attribute, dataAttributeValueMap, chooseComponent }) => {
  const params = useParams();
  const isMapButton = Common.isMapButtonActive(attribute);
  const isRequestedLocation =
    attribute.column_name === Config.ATTRIBUTE_COLUMN_NAME.requestedLocation;
  const isMapDrawing = Common.isMapDrawing(attribute);
  const attrValue = dataAttributeValueMap.get(attribute.id);
  const attrValueText = dataAttributeValueMap.get(attribute.id)?.text || "";

  const isViaMesh =
    attribute.column_name === Config.ATTRIBUTE_COLUMN_NAME.viaMesh;
  const isRoad = attribute.column_name === Config.ATTRIBUTE_COLUMN_NAME.road;

  useEffect(() => {
    var dataAttributeValueId = null;
    if (attrValue instanceof Array) {
      dataAttributeValueId = attrValue[0]?.id;
    } else {
      dataAttributeValueId = attrValue?.id;
    }
  }, [
    params.dataId,
    attrValue?.id,
    attribute.id,
    isViaMesh,
    isRoad,
    attrValue,
  ]);

  return (
    <>
      <tr className="height-80">
        <td
          className={`label ${
            (isMapButton || isRequestedLocation) && "map-button-active"
          }`}
        >
          {attribute.name}
          {isMapButton && (
            <OpenMapButton attribute={attribute} attrValue={attrValueText} />
          )}
          {isRequestedLocation && <DownloadGeoJsonButton />}
        </td>
      </tr>
      <tr className="">
        <td className={`content ${isMapDrawing && "uk-position-relative"}`}>
          {chooseComponent?.(attribute, dataAttributeValueMap)}
        </td>
      </tr>
    </>
  );
};

export default MapShowRows;
